import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useArtifactsQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectArtifactId: FC<ApiHelperSelectInputWrapperProps> = ({
  pathParameters,
  value,
  setValues,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: artifacts = [], isInitialLoading: isArtifactsLoading } = useArtifactsQuery(
    {
      processId: pathParameters.process_id as string,
      processRunId: pathParameters.process_run_id as string,
      activityRunId: pathParameters.step_run_id as string,
    },
    {
      enabled: !!(
        pathParameters.process_id &&
        pathParameters.process_run_id &&
        pathParameters.step_run_id
      ),
    },
  );

  const artifactItems = useMemo(
    () =>
      artifacts.map((item) => {
        return {
          label: item.fileName,
          value: item.id,
        };
      }),

    [artifacts],
  );

  const onChange = useCallback(
    (artifactId: string) => {
      const { fileName } = artifacts.find((item) => item.id === artifactId) ?? {};
      setValues((previous) => ({
        ...previous,
        artifact_id: artifactId,
        file_name: fileName,
      }));
    },
    [artifacts, setValues],
  );

  return (
    <ApiHelperSelectInput
      label={t('chooseArtifact')}
      items={artifactItems}
      onChange={onChange}
      value={value}
      loading={isArtifactsLoading}
      noItemsFound={t('noArtifactsForRun')}
      {...props}
    />
  );
};
